// extracted by mini-css-extract-plugin
export default {"AppreciationEditor":"styles_AppreciationEditor__aRPgr","welcome":"styles_welcome__pIEjt","buttons":"styles_buttons__S1BUj","cancelButton":"styles_cancelButton__0Z0BW"};